export const CHOGHADIYA_COPY = {
  en: {
    kicker: "Aaj Ka Choghadiya",
    heading: "Today's Choghadiya",
    loadingLabel: "Loading today's Choghadiya",
    loadingBody: "Calculating day and night Choghadiya for your city",
    fetchError: "Failed to load Choghadiya",
    retry: "Try Again",
    trust: ["Accurate Vedic calculations", "Updated Daily", "100% Free"],
    rating: "Was today's Choghadiya accurate for your city?",
  },
  hi: {
    kicker: "Aaj Ka Choghadiya",
    heading: "Aaj Ka Choghadiya",
    loadingLabel: "Aaj ka Choghadiya load ho raha hai",
    loadingBody: "Aapke city ke din aur raat ka Choghadiya calculate ho raha hai",
    fetchError: "Choghadiya load nahi ho saka",
    retry: "Dobara try karein",
    trust: ["Sateek Vedic calculations", "Daily updated", "100% free"],
    rating: "Kya aaj ka Choghadiya aapke city ke liye sahi tha?",
  },
} as const;
